var _path, _g, _path2, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H0V29H29V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29C22.5082 29 29 22.5082 29 14.5C29 6.49186 22.5082 0 14.5 0C6.49186 0 0 6.49186 0 14.5C0 22.5082 6.49186 29 14.5 29Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9699 15.9173V15.9156C15.8702 15.9228 15.3564 15.9536 14.21 15.9536C13.2947 15.9536 12.6504 15.9264 12.4238 15.9156V15.9183C8.90028 15.7633 6.27034 15.1498 6.27034 14.4157C6.27034 13.6826 8.90028 13.069 12.4238 12.9114V15.3075C12.654 15.3238 13.3137 15.3628 14.2254 15.3628C15.3193 15.3628 15.8675 15.3174 15.9699 15.3083V12.9131C19.4862 13.0699 22.1098 13.6835 22.1098 14.4157C22.1098 15.1498 19.4862 15.7615 15.9699 15.9173ZM15.9699 12.6639V10.5197H20.8764V7.25H7.51734V10.5197H12.4238V12.663C8.43628 12.8461 5.4375 13.6364 5.4375 14.5825C5.4375 15.5286 8.43628 16.3179 12.4238 16.5019V23.3731H15.9699V16.5001C19.9511 16.317 22.9427 15.5277 22.9427 14.5825C22.9427 13.6373 19.9511 12.8479 15.9699 12.6639Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 15,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17H17V32H32V17Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_22_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 15,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17H17V32H32V17Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_22_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 32C28.6421 32 32 28.6421 32 24.5C32 20.3579 28.6421 17 24.5 17C20.3579 17 17 20.3579 17 24.5C17 28.6421 20.3579 32 24.5 32Z",
    fill: "#EF0027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0462 21.5263L20.2812 20.2812L23.8414 29.24L28.8022 23.196L27.0462 21.5263ZM26.9375 22.0747L27.9725 23.0586L25.1422 23.571L26.9375 22.0747ZM24.5272 23.4683L21.544 20.9942L26.42 21.8914L24.5272 23.4683ZM24.3149 23.9061L23.8283 27.9279L21.2057 21.3265L24.3149 23.9061ZM24.7649 24.1193L27.8994 23.5522L24.304 27.9317L24.7649 24.1193Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.249d0e4c43dd723612b9250b84a9a1dc.svg";
export { ForwardRef as ReactComponent };